/**
 * Email enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Email provider labels
export const emailProviderLabels = {
    gmail: 'Gmail',
    outlook: 'Outlook',
};
export const emailProviderValues = Object.keys(emailProviderLabels);
//# sourceMappingURL=email.js.map